import React, { Component } from 'react';
import { setFirstTimePassword } from 'util/user-manager';
import { createNotification } from 'util/util';

class NewPasswordModal extends Component {
  constructor(props) {
    super(props);

    this.onNewPasswordChange.bind(this);
    this.onConfirmPasswordChange.bind(this);
    this.state = {
      newPassword: null,
      confirmPassword: null,
    };
  }

    onNewPasswordChange = (e) => {
      this.setState({
        newPassword: e.target.value,
      });
    };

    onConfirmPasswordChange = (e) => {
      this.setState({
        confirmPassword: e.target.value,
      });
    };

    checkAndSetPassword = () => {
      if (this.state.newPassword === this.state.confirmPassword) {
        setFirstTimePassword(this.state.newPassword, cognitoUser);
      }
      else {
        createNotification('Password do not match.', 'Error', 'Error');
      }
    }

    render =() => {
      return (
        <div className="modal fade profile-popupWrapper" id="newPasswordModal">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header py-2">
                <h4 className="modal-title">Create New Password</h4>
                <button type="button" className="close" data-dismiss="modal">&times; <p>Close</p></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-3 profile-img pb-3">
                    <img src="../../../../../assets/images/profile-img1.png" alt="profile-img" />
                  </div>
                  <div className="col-9 profile-detail pt-4">
                    <table className="table">
                      <tbody>
                        <tr>
                          <td>New password</td>
                          <td><input type="password" onChange={(e) => { this.onNewPasswordChange(e); }} /></td>
                        </tr>
                        <tr>
                          <td>Confirm password</td>
                          <td><input type="password" onChange={(e) => { this.onConfirmPasswordChange(e); }} /></td>
                        </tr>
                        <tr>
                          <td />
                          <td><button onClick={this.checkAndSetPassword} className="btn btn-success">Update Password</button></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
}
export default NewPasswordModal;



// WEBPACK FOOTER //
// ./app/routes/components/routes/NewPasswordModal/NewPasswordModal.js